// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__q6AC8","inner":"styles_inner__qbW7l","headImg":"styles_headImg__YJSKb","lvlImg":"styles_lvlImg__Om2Z6","iconImg":"styles_iconImg__h8g_E"};